import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import OfferCardLoadingSkeleton from 'components/OfferList/OfferCards/OfferCardLoadingSkeleton'
import FullWidthCarouselWithAnalytics from 'components/WithAnalytics/Carousel/FullWidthCarouselWithAnalytics'
import Group from 'components/utils/Group'
import PillLoadingBox from 'LuxKit/Pill/PillLoadingBox'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import styled from 'styled-components'
import { LOCAL_DESTINATION_OFFER_CAROUSEL_MODULE_ID } from './localDestinationOfferCarouselAnalytics'

const SkeletonContainer = styled(VerticalSpacer)`
  padding-block-start: 0;
  padding-block-end: 0;
`

/**
 * Reserves carousel content height while eligibility resolves. Block padding is
 * owned by the parent TrendingDestinations section; the loaded carousel uses
 * `OFFER_CARD_CAROUSEL_SECTION_NESTED_CLASS` on OfferCardCarouselSection.
 */
function LocalDestinationOfferCarouselSkeleton() {
  return (
    <SkeletonContainer
      gap={20}
      data-testid={`${LOCAL_DESTINATION_OFFER_CAROUSEL_MODULE_ID}-skeleton`}
      aria-hidden
    >
      <LayoutContainer>
        <VerticalSpacer gap={20}>
          <TextLoadingBox typography="heading2" width="28ch" />
          <Group direction="horizontal" gap={4}>
            <PillLoadingBox width={88} />
            <PillLoadingBox width={72} />
            <PillLoadingBox width={96} />
            <PillLoadingBox width={80} />
          </Group>
        </VerticalSpacer>
      </LayoutContainer>
      <FullWidthCarouselWithAnalytics snap="start" itemsPerArrow={3}>
        <OfferCardLoadingSkeleton size="medium" />
        <OfferCardLoadingSkeleton size="medium" />
        <OfferCardLoadingSkeleton size="medium" />
        <OfferCardLoadingSkeleton size="medium" />
      </FullWidthCarouselWithAnalytics>
    </SkeletonContainer>
  )
}

export default LocalDestinationOfferCarouselSkeleton
